import React from 'react';

const FilterCalendarIcon = (props: any) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M6.25375 2.5V5.00104" stroke="#1F221F" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M13.7567 2.5V5.00104" stroke="#1F221F" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M2.50195 7.92075H17.5082"
      stroke="#1F221F"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <rect
      x="2.50195"
      y="3.75391"
      width="15.0062"
      height="13.7557"
      rx="3"
      stroke="#1F221F"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default FilterCalendarIcon;
